import { useSearchParams } from '@remix-run/react'

export function useAlleleParams() {
	const [searchParams, setSearchParams] = useSearchParams()
	const selectedAllele = searchParams.getAll('allele')
	function toggleAlleleParam(alleleId: string) {
		if (selectedAllele.includes(alleleId)) {
			setSearchParams(searchParams => {
				searchParams.delete('allele', alleleId)
				return searchParams
			})
		} else {
			setSearchParams(searchParams => {
				searchParams.append('allele', alleleId)
				return searchParams
			})
		}
	}
	return { selectedAllele, toggleAlleleParam }
}
